import { useAuth } from "../auth/AuthProvider";
import { EnvironmentGate, EnvironmentPicker } from "../components/Environment";
import { actsAsCustomer, moduleById } from "../lib/modules";
import { CustomerListView } from "./CustomersPage";

/** Staff see every customer's findings at once; a customer goes straight to their environment's checks. */
export function TrustedAdvisorPage() {
  const { me } = useAuth();
  const module = moduleById("trusted-advisor");
  if (actsAsCustomer(me)) return <EnvironmentGate module={module} />;
  return <CustomerListView source="trusted_advisor" title="Trusted Advisor" countLabel="Findings" actions={<EnvironmentPicker module={module} environmentId={undefined} />} />;
}
